class JUDEShadesElement extends HTMLElement {
  static {
    customElements.define("jude-shades", this)
  }

  connectedCallback() {
    setTimeout(() => {
      const color = this.getAttribute("sticky-color")
      const colorSelect = this.nextElementSibling.querySelector("wa-select")
      colorSelect.value = color
      colorSelect.addEventListener("change", this)
    })
  }

  handleEvent(event) {
    if (event.type === "change") {
      this.setAttribute("sticky-color", event.target.value)
      this.querySelector("jude-prose").save(true)
    }
  }

  get saveData() {
    const data = {
      color: this.getAttribute("sticky-color")
    }

    return data
  }
}
